import React from 'react';
import Typography from "@material-ui/core/Typography";
import "../../../index.css";

const TextFalse = () => {

    return (
        <Typography className='alignCenter'>
            Create a recipe!
        </Typography>
    )
};

export default TextFalse;